import axios from "axios";
import { BaseUrl, JsonConfig } from "./BaseRepository.js";

// Api request for discarding all drafted adjustments
export const DiscardAllAdjustmentsApi = async (PayFrequency) => {
    try {
        const URL = BaseUrl + "Spectranet/DiscardData";
        const Response = await axios.put(URL, PayFrequency,JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch {
        return null;
    }
}

//Api request for Fetching Adjustments data for Grid
export const FetchAllAdjustments = async (PayFrequency) => {
    try{
        const URL = BaseUrl + "Spectranet/GettingTheUpdatedDataIntoGrid?PayFrequency="+PayFrequency;
        const Response = await axios.get(URL, JsonConfig);
        const JsonResponse = Response != null ? JSON.parse(Response.data): null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Fetching Employee data using File Number
export const FindEmployeeByFileNumber = async (fileNumber) => {
    try{
        const URL = BaseUrl+"Spectranet/MasterFileDataInDetail?fileNumber="+fileNumber;
        const Response = await axios.get(URL, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Adding Single Adjustment through Form
export const AddSingleAdjustment = async (NewAdjustment, Frequency) => {
    try{
        const Data = {adjustments_Model:NewAdjustment, PayFrequency:Frequency}
        const URL = BaseUrl + "Spectranet/PostDataAdjustements?PayFrequency="+ Frequency;
        const Response = await axios.post(URL,NewAdjustment , JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}